




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { IconDefinition, faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import {CompaniesListSortModel, CreateEmployeeRequestModel, CompanyModel, StatusType, ColorTheme, SortDirectionModel} from '@/services/types'
import {StoreActionTypes} from '@/store/types'
import CreateCompanyEmployeeModalForm from '@/components/form/CreateCompanyEmployeeModalForm.vue'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import ConfirmationComponent from '@/components/modal/ConfirmationComponent.vue'


@Component({
    components: {
        CreateCompanyEmployeeModalForm,
        ModalComponent,
        ConfirmationComponent
    }
}) 
export default class GridComponent extends Vue {
    private componentClass = "GridComponent"
    private sortBy = 'name'
    private sortDesc = false
    private fields = [
        { key: 'name', sortable: true, label: 'Название', tdClass: 'name-td', thClass: 'name-th' },
        { key: 'status', sortable: true, label: 'Статус лицензии', tdClass: 'status-td', thClass: 'status-th' },
        { key: 'action', label: '', sortable: false, tdClass: 'action-td', thClass: 'action-th' }               
    ]

    private ellipsis: IconDefinition = faEllipsisV
    private modalShow = false
    private selectedCompanyId = null
    private deleteCompanyConfirmationShow = false
    private changeStatusCompanyConfirmationShow = false
    private editedCompanyId: number | null = null
    

    sortingChanged(ctx: SortDirectionModel) {
        this.sortBy = ctx.sortBy
        this.sortDesc = ctx.sortDesc
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST_SORT, {
            sort: ctx.sortBy,
            direction: ctx.sortDesc ? 'desc' : 'asc'
        })
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
    }

    mounted() {
        this.sortBy = (this.$store.getters.getCompaniesSortValue as CompaniesListSortModel).sort
        this.sortDesc = this.getsortDesc()
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
    }

    get listItems(): CompanyModel [] {
        return this.$store.getters.getCompaniesList
    }

    getsortDesc(): boolean {
        const direction = (this.$store.getters.getCompaniesSortValue as CompaniesListSortModel).direction        
        return direction == 'desc' 
    }

    getStatusTitle(status: StatusType) {
        return status == 'ACTIVE' ? 'Активна' : 'Деактивирована'
    }

    getChangeStatusItemTitle(status: StatusType) {
        return status == 'ACTIVE' ? 'Деактивировать' : 'Активировать'
    }

    handleChangeStatusItemClick(id: number) {
        this.editedCompanyId = id
        this.changeStatusCompanyConfirmationShow = true
    }

    async handleModalOkBtnClick() {
        const model: CreateEmployeeRequestModel = (this.$refs.createNewCompanyEmployeeForm as CreateCompanyEmployeeModalForm).getCreateEmployeeRequestModel()
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_SELECTED_COMPANY, this.selectedCompanyId)
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_CREATE, model)
        this.$router.push(`companies/${this.selectedCompanyId}`)
    }

    async handleCreateNewCompanyEmployeeBtnClick(id: number) {
        this.selectedCompanyId = id        
        this.modalShow = !this.modalShow
    }

    get createNewCompanyEmployeeFormDisabled (){
        return this.$store.getters.isEmployeesDataLoading
    }

    get getModalTitle() {
        return this.selectedCompanyId ? this.listItems.find(item => item.id == this.selectedCompanyId).name : ''
    }

    handleRowClick(item: CompanyModel) {
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_SELECTED_COMPANY_CLEAR)
        this.$router.push(`companies/${item.id}`)
    }

    handleDeleteItemClick(id: number) {
        this.editedCompanyId = id
        this.deleteCompanyConfirmationShow = true
    }

    get getEditedCompanyName() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedCompanyId) ? this.listItems.find(item => item.id == this.editedCompanyId).name : ''
    }

    get editedCompanyDisabled() {
        return this.$store.getters.isCompaniesDataLoading
    }

    async deleteCompany() {
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_COMPANY_DELETE, {
            ids: [this.editedCompanyId]
        })

        this.deleteCompanyCancel()
    }

    deleteCompanyCancel() {
        this.editedCompanyId = null
        this.deleteCompanyConfirmationShow = false
    }

    changeCompanyStatusCancel() {
        this.editedCompanyId = null
        this.changeStatusCompanyConfirmationShow = false
    }

    getEditedCompanyStatus() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedCompanyId) ? this.listItems.find(item => item.id == this.editedCompanyId).status : null
    }

    get getEditedCompanyOkTitle() {
        return this.getChangeStatusItemTitle(
            this.getEditedCompanyStatus()
        )
    }

    async changeCompanyStatus() {
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_COMPANY_CHANGE_STATUS, {
                id: this.editedCompanyId, 
                status: this.getEditedCompanyStatus()
            })
        this.changeCompanyStatusCancel()
    }

    get setChangeStatusConfirmationOkBtnVariant() {
        return this.getOkBtnVariant(
            this.getEditedCompanyStatus()
        )
    }
    
    getOkBtnVariant(status: StatusType): ColorTheme {
        return status == 'ACTIVE' ? 'danger' : 'success'
    }
}
